var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6759 0.625C8.75061 0.625 0.675781 8.69956 0.675781 18.6247C0.675781 24.6794 3.68088 30.0455 8.27797 33.3098L18.6759 30.4019L28.7328 33.5461C33.5217 30.3083 36.6758 24.8278 36.6758 18.6247C36.6758 8.69956 28.6011 0.625 18.6759 0.625Z",
    fill: "#FBE9AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6762 22.4492C13.2981 22.4492 8.83316 26.4792 8.29031 31.8233C8.28237 31.9016 8.27832 31.9803 8.27832 32.059V33.3102C11.2168 35.3969 14.8057 36.6249 18.6762 36.6249C22.5466 36.6249 26.1355 35.3969 29.0741 33.3102V32.059C29.0741 31.9803 29.0702 31.9017 29.0621 31.8233C28.5193 26.4792 24.0543 22.4492 18.6762 22.4492Z",
    fill: "#F3D0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6762 22.4492C13.2981 22.4492 8.83316 26.4792 8.29031 31.8233C8.28237 31.9016 8.27832 31.9803 8.27832 32.059V33.3102C11.2168 35.3969 14.8057 36.6249 18.6762 36.6249C22.5466 36.6249 26.1355 35.3969 29.0741 33.3102V32.059C29.0741 31.9803 29.0702 31.9017 29.0621 31.8233C28.5193 26.4792 24.0543 22.4492 18.6762 22.4492Z",
    fill: "#081731"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6883 12.2567C22.6538 12.2646 25.8619 15.4851 25.854 19.4497C25.846 23.4143 22.6251 26.6219 18.6596 26.614C14.694 26.6061 11.4859 23.3856 11.4939 19.421C11.5018 15.4564 14.7228 12.2487 18.6883 12.2567Z",
    fill: "white",
    stroke: "#081731"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.42c8d7886a9e876503d1179efa1b81af.svg";
export { ForwardRef as ReactComponent };